$ = require 'jquery'
Action = require 'app/scripts/models/action'
Alerts = require 'app/scripts/views/lib/alerts'
ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
Card = require 'app/scripts/models/card'
Controller = require 'app/scripts/controller'
Dates = require 'app/scripts/lib/dates'
Highlight = require 'app/scripts/views/home/highlight'
List = require 'app/scripts/models/list'
memoizeOne = require('memoize-one').default
Member = require 'app/scripts/models/member'
ModelLoader = require 'app/scripts/db/model-loader'
NewUserOrientationCard = require 'app/scripts/views/home/new-user-orientation-card'
Organization = require 'app/scripts/models/organization'
Promise = require 'bluebird'
React = require 'react'
TFM = require 'app/scripts/lib/markdown/tfm'
UndoDismissSnackbar = require 'app/scripts/views/home/undo-dismiss-snackbar'
UpNext = require 'app/scripts/views/home/up-next'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
startDecayingInterval = require 'app/scripts/lib/util/decaying-interval'
t = require('app/scripts/views/internal/recup-with-helpers')('home')
{ Apdex } = require '@trello/atlassian-analytics'
TrelloPerf = require('app/common/debug/perf').default
{ flushPerformanceMetrics } = require 'app/common/debug/flushPerformanceMetrics'
PerfKeys = TrelloPerf.Keys
{ trackUe } = require '@trello/analytics'
{ ContentSkeleton } = require 'app/scripts/views/home/presentational/content-skeleton'
{ FixedSectionHeaderButton } = require './presentational/section-header'
{ HighlightSection } = require './presentational/highlight-section'
{ OrientationCard } = require './presentational/orientation-card'
{ UpNextSection } = require './presentational/up-next-section'
{ getScrollParent } = require 'app/common/lib/dom/get-scroll-parent'
{ UnsplashTracker } = require '@trello/unsplash'
ReactionList = require 'app/scripts/models/collections/reaction-list'
{ LazyActionableTaskView } = require 'app/src/components/ActionableTaskView'
{ ComponentWrapper } = require 'app/src/components/ComponentWrapper'


MAX_PAGE_RESULTS = 20

module.exports = class HomeMainContentContainer extends React.Component
  displayName: 'HomeMainContentContainer'

  constructor: (props) ->
    super props

    @dismissTimeout = null
    @unresolvedPromises = new Set()
    @upNextOptimisticallyUpdated = false

    @state = {
      fixedButtons: {}
      idActions: []
      loadingInitial: true
      loadingMore: false
      moreHighlightsAvailable: false
      mostRecentDismissedUpNext: null
      newUpNextCards: []
      numUpNextCardsVisible: 1
      shouldShowUndoDismiss: false
      unreadIdActions: []
      upNextCards: []
      waitingForBoardsData: true
    }

    @reactionListGroup = {}

  isUpNextCardsFromOtherUsers: memoizeOne (newUpNextCards, currentUpNextCards) ->
    { modelCache } = @props

    newUpNexts = @getVisibleNewUpNexts(newUpNextCards)
    currUpNexts = @getVisibleUpNexts(currentUpNextCards)

    ids = (upNexts) -> upNexts.map((upNext) -> upNext.id)

    # Never show "Show new items" if the new set is empty.
    if newUpNexts.length == 0
      return false

    # Always show "Show new items" if items were removed.
    if _.difference(ids(currUpNexts), ids(newUpNexts)).length > 0
      return true

    # Ignore new items caused by adding yourself to a card.
    upNextNotFromSelf = (upNext) ->
      if upNext.item.type == 'action'
        action = modelCache.get('Action', upNext.item.actionId)
        memberCreator = modelCache.get('Member', action?.get('idMemberCreator'))
        return !Auth.isMe(memberCreator)

      return true

    return !_.isEqual(
      ids(newUpNexts.filter(upNextNotFromSelf)),
      ids(currUpNexts.filter(upNextNotFromSelf))
    )

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      @setState(waitingForBoardsData: false)

      upNextCardsRequest = Promise.resolve()
      highlightsRequest = Promise.resolve()

      if !@showNewUserCard() && @onHomeTab()
        upNextCardsRequest = @fetchUpNextCards()

        upNextCardsRequest.then (upNextCards) =>
          @setState
            upNextCards: upNextCards
          @startPollingForUpNextCards()

      if !@showNewUserCard()
        highlightsRequest = @fetchHighlights({})

        highlightsRequest.then (idActions) =>
          @setState
            idActions: idActions
          @startPollingforHighlights()

      Promise.all([upNextCardsRequest, highlightsRequest]).then =>
        @setState
          loadingInitial: false
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e
        @setState
          loadingInitial: false

      Promise.all([upNextCardsRequest, highlightsRequest]).then ->
        # Deferring here to allow React to render before measuring
        setTimeout ->
          Apdex.stop(task: 'memberHome')

          TrelloPerf.stopMeasurement(PerfKeys.BOOTSTRAP_HOME_VIEW)
          TrelloPerf.reportStartupMetrics()
          flushPerformanceMetrics
            buffered: TrelloPerf.getCachedMetrics()
            flush: -> TrelloPerf.clearCachedMetrics()
        , 0

  componentWillUnmount: ->
    if @cancelUpNextDecayingInterval
      @cancelUpNextDecayingInterval()

    if @cancelHighlightsDecayingInterval
      @cancelHighlightsDecayingInterval()

    if @dismissTimeout
      clearTimeout(@dismissTimeout)

    @unresolvedPromises.forEach((promise) -> promise.cancel())

  componentDidUpdate: ->
    @setDateFirstSawHighlights()

  cancelOnUnmount: (promise) =>
    promise
      .cancellable()
      .then => @unresolvedPromises.delete(promise)
      .catch Promise.CancellationError, (->)
    @unresolvedPromises.add(promise)

    return promise

  onHomeTab: =>
    !@props.orgname

  currentOrg: memoizeOne (orgname) ->
    { modelCache } = @props

    modelCache.findOne('Organization', 'name', orgname)

  currentOrgId: memoizeOne (orgname) ->
    @currentOrg(orgname)?.id

  isFirstBoard: =>
    me = Auth.me()
    ownedBoards = _.filter me.boardList.models, (board) -> board.owned()
    openBoards = _.filter me.boardList.models, (board) -> board.isOpen()

    # Only has a welcome boards or no boards at all
    return ownedBoards.filter((board) => !board.isWelcomeBoard()).length == 0

  showNewUserCard: =>
    { orgname } = @props
    { waitingForBoardsData } = @state

    if waitingForBoardsData
      return false

    me = Auth.me()

    if @onHomeTab()
      if me.isDismissed('homeNewUserCard')
        return false

      return @isFirstBoard()

    if @currentOrgId(orgname)
      if me.isDismissed("homeNewUserCard_#{@currentOrgId(orgname)}")
        return false

      openBoards = _.filter me.boardList.models, (board) -> board.isOpen()
      openOrgBoards = openBoards.filter((board) => board.getOrganization()?.id == @currentOrgId(orgname))

      return openOrgBoards.length == 0

  newUserCanDismiss: =>
    return @showNewUserCard()

  # Up Next Functions Start
  getVisibleUpNexts: memoizeOne (upNexts) ->
    upNexts.filter(({ dismissed }) -> !dismissed)

  getVisibleNewUpNexts: memoizeOne (newUpNexts) ->
    newUpNexts.filter(({ dismissed }) -> !dismissed)

  getUpNextById: (upNexts, upNextId) ->
    upNexts.find(({ id }) -> id == upNextId)

  unsplashTrackNewUpNext: (newIds, upNextCards) ->
    trackingPaths = upNextCards.filter((upNext) =>
      newIds.includes(upNext.id)).map((upNext) =>
        board = @props.modelCache.get('Board', upNext.boardId)
        board.attributes.prefs.backgroundImage)
    UnsplashTracker.trackOncePerInterval(trackingPaths.filter (tp) -> !!tp)

  renderUpNext: (upNextCard) =>
    { id, cardId, listId, boardId, orgId, item } = upNextCard

    if item.type == 'action'
      action = @props.modelCache.get('Action', item.actionId)
      if !@reactionListGroup.hasOwnProperty(item.actionId)
        @reactionListGroup["#{item.actionId}"] = new ReactionList().syncCache @props.modelCache, [], (reaction) =>
          reaction.get('idModel') == item.actionId

    React.createElement UpNext, {
      @dismissUpNextCard
      @optimisticallyDismissCard
      boardId
      cardId
      item
      key: id
      listId
      modelCache: @props.modelCache
      orgId
      setFocusedCard: @props.setFocusedCard
      upNextId: id
      reactionList: if item.type == 'action' then @reactionListGroup["#{item.actionId}"]
      idAction: if item.type == 'action' then item.actionId
    }

  updateUpNextCards: (callback) =>
    @fetchUpNextCards().then (upNextCards) =>
      @setState((prevState, props) =>
        currUpNextIds = @getVisibleUpNexts(prevState.upNextCards).map((card) => card.id)
        newUpNextIds = upNextCards.map((card) => card.id)
        isNewUpNext = !_.isEqual(currUpNextIds, newUpNextIds)

        if isNewUpNext
          @unsplashTrackNewUpNext(newUpNextIds, upNextCards)

          # collect all "action" ids
          actionIds = upNextCards
            .filter (upNextCard) => upNextCard.item.type == 'action'
            .map (upNextCard) => upNextCard.item.actionId
          # prune dismissed reactionLists
          for own reactionAction of @reactionListGroup
            usedReactionList = actionIds.some (id) -> id == reactionAction
            if !usedReactionList
              delete @reactionListGroup["#{reactionAction}"]

          return { newUpNextCards: upNextCards }

      , callback)

  fetchUpNextCards: =>
    { modelCache } = @props

    @cancelOnUnmount(ModelLoader.loadUpNext())
      .then (response) =>
        upNextCards = response.upNext.map (upNextItem) =>
          item = upNextItem.items[0] # for initial release there is only 1 item
          item.actionId = modelCache.get('Action', item.data.idAction)?.id

          card = modelCache.get('Card', upNextItem.data.idCard)
          board = card.getBoard()

          return {
            id: upNextItem.id
            cardId: card.id
            listId: card.get('idList')
            boardId: board.id
            orgId: board.get('idOrganization')
            dismissed: false
            item
          }

        return upNextCards

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  startPollingForUpNextCards: =>
    @cancelUpNextDecayingInterval = startDecayingInterval =>
      if @upNextOptimisticallyUpdated
        # Skip one poll result if the user made an API request
        # within the last poll. This prevents stale data from
        # overwriting the client-side optimistic dismissing before
        # the API request finishes.
        @upNextOptimisticallyUpdated = false
      else
        @updateUpNextCards()

  onShowMoreUpNextClick: =>
    trackUe('home', 'shows more', 'cards', '', '', 'by clicking show more in up next feed')
    @setState (prevState, props) ->
      numUpNextCardsVisible: prevState.numUpNextCardsVisible + 6

  showNewUpNextItems: (e) =>
    Util.preventDefault(e)

    { orgname } = @props

    method = 'by clicking load new items button in up next feed'
    context = {}

    if @currentOrgId(orgname)
      method = 'by clicking load new items button in up next feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId(orgname) })

    trackUe('home', 'loads more', 'cards', '', '', method, context)

    @setState (prevState, props) ->
      upNextCards: prevState.newUpNextCards
      newUpNextCards: []

  optimisticallyDismissCard: (upNextId, dismissed = true, delay = true) =>
    # optimistically dismiss card with a slight delay
    dismiss = =>
      @setState (prevState, props) ->
        mapUpNext = (upNext) ->
          if upNext.id != upNextId
            upNext
          else
            Object.assign({}, upNext, {
              dismissed: dismissed
            })

        upNextCards = prevState.upNextCards.map(mapUpNext)
        newUpNextCards = prevState.newUpNextCards.map(mapUpNext)

        if upNextCards.length == 0 && newUpNextCards.length > 0
          # if it's the last card that we dismissed and there are new cards that we can show let's show the
          return {
            upNextCards: newUpNextCards
            newUpNextCards: []
          }

        return {
          upNextCards
          newUpNextCards
        }

    if delay
      @dismissTimeout = setTimeout(dismiss, 250)
    else
      dismiss()

    @upNextOptimisticallyUpdated = true

  dismissUpNextOrientationCard: =>
    trackUe('home', 'dismisses', 'intro component', 'on up next feed', '', 'by clicking dismiss link in up next intro card')
    Auth.me().dismiss('homeUpNextOrientationCard')

  dismissUpNextCard: (cardId, upNextId, trackingPrepositionalObject) =>
    trackUe('home', 'dismisses', 'card', trackingPrepositionalObject, '', 'by clicking dismiss button in up next card', { cardId: cardId })
    @optimisticallyDismissCard(upNextId, true)

    @setState (prevState) =>
      mostRecentDismissedUpNext: @getUpNextById(prevState.upNextCards, upNextId)
      shouldShowUndoDismiss: true

    @cancelOnUnmount(ApiPromise
      url: "1/members/me/upNext/#{upNextId}"
      type: "PUT"
      data:
        dismissed: true
    ).done()

  undoDismissUpNext: (upNextId) =>
    cardId = @getUpNextById(@state.upNextCards, upNextId)?.card?.id
    trackUe('home', 'undismisses', 'card', '', '', 'by clicking undo button in snackbar', { cardId: cardId })

    @optimisticallyDismissCard(upNextId, false)

    @cancelOnUnmount(ApiPromise
      url: "1/members/me/upNext/#{upNextId}"
      type: "PUT"
      data:
        dismissed: false
    ).done()

  closeUndoDismissUpNext: =>
    @setState(shouldShowUndoDismiss: false)
  # Up Next Functions End

  # Highlights Functions Start
  fetchHighlights: ({ before, since }) =>
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    if (orgname && !orgId)
      # if there is no orgId when there is an orgname it means that you no longer can see that team
      # this fixes an issue when you're deactivated from a team, but the update to the model hasn't
      # flown down and redirected the page, so we make a bad request by fetching highlights for that team
      return new Promise (resolve) -> []

    @cancelOnUnmount(ModelLoader.loadHighlights({ before, since, organization: orgId }))
      .then (response) =>
        trackingPaths = []
        highlightCards = response.highlights.map (action) =>
          card = _.findWhere response.cards, id: action.data.card.id
          list = _.findWhere response.lists, id: card.idList
          board = _.findWhere response.boards, id: card.idBoard
          org = _.findWhere response.organizations, id: board.idOrganization

          board.organization = org
          card.list = list
          card.board = board
          action.card = card
          action.list = list
          action.board = board

          if board.prefs.backgroundImage?
            trackingPaths.push(board.prefs.backgroundImage)

          # Side effect: Action gets loaded into modelCache.
          action = new Action(action, modelCache: modelCache)
          return action.id

        UnsplashTracker.trackOncePerInterval trackingPaths

        if !since
          @setState
            moreHighlightsAvailable: highlightCards.length == MAX_PAGE_RESULTS

        return highlightCards

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  mostRecentIdAction: =>
    { idActions, unreadIdActions } = @state

    return unreadIdActions[0] ? idActions[0] ? ''

  showUnreadActionsButton: =>
    { unreadIdActions } = @state
    { modelCache } = @props

    isActionsFromOtherUsers = unreadIdActions.some (actionId) ->
      action = modelCache.get('Action', actionId)
      memberCreator = modelCache.get('Member', action.get('idMemberCreator'))
      !Auth.isMe(memberCreator)

    return isActionsFromOtherUsers

  pollHighlights: =>
    { modelCache } = @props
    @fetchHighlights({ since: @mostRecentIdAction() }).then (newIdActions) =>
      if newIdActions.length
        @setState (prevState, props) ->
          unreadIdActions: newIdActions.concat prevState.unreadIdActions

  startPollingforHighlights: =>
    @cancelHighlightsDecayingInterval = startDecayingInterval(@pollHighlights)

  showUnreadHighlights: (e) =>
    Util.preventDefault(e)

    { orgname } = @props

    method = 'by clicking load new activity button in highlights feed'
    context = {}

    if @currentOrgId(orgname)
      method = 'by clicking load new activity button in highlights feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId(orgname) })

    trackUe('home', 'loads more', 'cards', '', '', method, context)

    @setState (prevState, props) ->
      idActions: prevState.unreadIdActions.concat prevState.idActions
      unreadIdActions: []

  loadMoreHighlights: (e) =>
    Util.preventDefault(e)

    { orgname } = @props

    method = 'by clicking show more activity in highlights feed'
    context = {}

    if @currentOrgId(orgname)
      method = 'by clicking show more activity in highlights feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId(orgname) })

    trackUe('home', 'shows more', 'cards', '', '', method, context)

    @setState
      loadingMore: true
    @fetchHighlights({ before: @state.idActions[@state.idActions.length - 1] }).then (idActions) =>
      @setState (prevState, props) ->
        idActions: prevState.idActions.concat(idActions)
        loadingMore: false
    .catch (e) =>
      if e instanceof Promise.CancellationError
        throw e
      @setState
        loadingMore: false

  dismissHighlightsOrientationCard: =>
    { orgname } = @props

    method = 'by clicking dismiss button in highlights intro card'
    context = {}

    if @currentOrgId(orgname)
      method = 'by clicking dismiss button in highlights intro card when filtered by team'
      Object.assign(context, { teamId: @currentOrgId(orgname) })

    trackUe('home', 'dismisses', 'intro component', 'on highlights feed', '', method, context)
    Auth.me().dismiss('homeHighlightsOrientationCard')

  dismissFeedbackOrientationCard: ->
    Auth.me().dismiss('homeFeedbackOrientationCard')

  setDateFirstSawHighlights: ->
    { idActions } = @state
    if idActions.length && !Auth.me().getDateFirstSawHighlights()
      Auth.me().setDateFirstSawHighlights()

  dismissHighlightsCard: (idAction) =>
    @setState (prevState) ->
      idActions: prevState.idActions.filter (id) -> id != idAction
  # Highlights Functions End

  dismissNewUser: =>
    { orgname } = @props

    dismissKey = if @currentOrgId(orgname) then "homeNewUserCard_#{@currentOrgId(orgname)}" else 'homeNewUserCard'
    Auth.me().dismiss(dismissKey)

  setHighlightsFixedButton: (shouldShow) =>
    @setState ({ fixedButtons }) ->
      fixedButtons: Object.assign({}, fixedButtons, highlights: shouldShow)

  setUpNextFixedButton: (shouldShow) =>
    @setState ({ fixedButtons }) ->
      fixedButtons: Object.assign({}, fixedButtons, upNext: shouldShow)

  setHighlightsWrapperRef: (ref) =>
    @ref ?= {}
    @ref.highlights = ref

  setUpNextWrapperRef: (ref) =>
    @ref ?= {}
    @ref.upNext = ref

  shouldShowFixedButton: ->
    { fixedButtons } = @state
    return fixedButtons.upNext || fixedButtons.highlights

  onClickFixedButton: =>
    { orgname } = @props

    scrollIntoView = (el) ->
      $(getScrollParent(el)).animate({
        scrollTop: el.offsetTop - 8
      })

    if @state.fixedButtons.upNext && @ref.upNext
      scrollIntoView(@ref.upNext)
    else if @state.fixedButtons.highlights && @ref.highlights
      scrollIntoView(@ref.highlights)

    @setState(fixedButtons: {})

    category = 'home'
    verb = 'scrolls to top'
    direct_object = 'activity feed'
    prepositional_object = ''
    indirect_object = if @currentOrgId(orgname) then 'on team tab' else 'on boards tab'
    method = 'by clicking fixed new activity button'
    context = if @currentOrgId(orgname) then { teamId: @currentOrgId(orgname) } else ''

    trackUe(category, verb, direct_object, prepositional_object, indirect_object, method, context)

  createBoard: ({ name, trackingOpts }) =>
    # can only create a private personal board
    # so setting idOrganization, prefs_permissionLevel, and prefs_selfJoin to defaults

    isFirstBoard = @isFirstBoard()

    # Data that we'll use in the body of the POST to create the board
    initialData = {
      name
      idOrganization: ''
    }

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: false
      defaultLists: isFirstBoard
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      @modelCache
      requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        boardId = board.get('id')

        if boardId !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(boardId))

        { category, method } = trackingOpts
        trackUe(category, 'adds', 'board', '', '', method, { boardId })

        # We have to wait until we get the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: boardId
          openListComposer: !isFirstBoard
          openCardComposerInFirstList: isFirstBoard
        }).done()

        return
      error: ->
        Alerts.flash('could not create board', 'error', 'create error')
    }

  renderHighlight: (idAction) =>
    { orgname, modelCache } = @props

    if !@reactionListGroup.hasOwnProperty(idAction)
      @reactionListGroup["#{idAction}"] = new ReactionList([]).syncCache modelCache, [], (reaction) =>
        reaction.get('idModel') == idAction

    React.createElement Highlight, {
      currentOrgId: @currentOrgId(orgname)
      key: idAction
      idAction: idAction
      modelCache: @props.modelCache
      setFocusedCard: @props.setFocusedCard
      onDismissClick: @dismissHighlightsCard
      reactionList: @reactionListGroup["#{idAction}"]
    }

  render: t.renderable ->
    { orgname, modelCache } = @props

    {
      idActions
      loadingInitial
      loadingMore
      moreHighlightsAvailable
      mostRecentDismissedUpNext
      newUpNextCards
      numUpNextCardsVisible
      shouldShowUndoDismiss
      upNextCards
      unreadIdActions
    } = @state

    t.div '.home-main-content-container', =>
      t.tag FixedSectionHeaderButton,
        shouldShow: @shouldShowFixedButton()
        onClick: @onClickFixedButton
        iconName: 'up'
      , ->
        t.format 'new-activity'

      t.tag UndoDismissSnackbar,
        shouldShow: shouldShowUndoDismiss
        idDismiss: mostRecentDismissedUpNext?.id
        boardName: modelCache.get('Board', mostRecentDismissedUpNext?.boardId)?.get('name')
        cardUrl: modelCache.get('Card', mostRecentDismissedUpNext?.cardId)?.get('url')
        close: @closeUndoDismissUpNext
        undo: @undoDismissUpNext

      if @onHomeTab()
        t.tag ComponentWrapper, ->
          t.tag LazyActionableTaskView

      if @showNewUserCard()
        t.tag NewUserOrientationCard, {
          key: 'new-user'
          onHomeTab: @onHomeTab()
          currentOrg: @currentOrg(orgname)
          modelCache: modelCache
          onCreateBoardClick: @createBoard
          onDismissClick: if @newUserCanDismiss() then @dismissNewUser
        }

      else
        if loadingInitial
          t.div ->
            t.tag ContentSkeleton

        else
          if !@getVisibleUpNexts(upNextCards).length && !idActions.length
            t.tag OrientationCard, {
              key: 'orientation'
              titleKey: 'orientation-no-content-title'
              textKey: 'orientation-no-content-text'
              backgroundName: 'no-content'
              isBackgroundTop: true
            }

          else
            if @onHomeTab()
              t.div '.home-main-content-item', { ref: (el) =>
                Dates.update(el)
                @setUpNextWrapperRef(el)
              }, =>
                t.tag UpNextSection, {
                  @dismissUpNextOrientationCard
                  @onShowMoreUpNextClick
                  @renderUpNext
                  @showNewUpNextItems
                  @optimisticallyDismissCard
                  key: 'up-next'
                  modelCache: modelCache
                  showUnreadUpNextActionsButton: @isUpNextCardsFromOtherUsers(newUpNextCards, upNextCards)
                  numUpNextCardsVisible
                  setFixedButton: @setUpNextFixedButton
                  shouldShowUpNextOrientationCard: !Auth.me().isDismissed('homeUpNextOrientationCard')
                  upNextCards: @getVisibleUpNexts(upNextCards)
                }

            t.div '.home-main-content-item', { ref: @setHighlightsWrapperRef }, =>
              t.tag HighlightSection, {
                key: 'highlights'
                myId: Auth.myId()
                idActions
                unreadIdActions
                loadingMore
                @loadMoreHighlights
                moreHighlightsAvailable
                @showUnreadHighlights
                @dismissHighlightsCard
                @dismissHighlightsOrientationCard
                @dismissFeedbackOrientationCard
                showUnreadActionsButton: @showUnreadActionsButton()
                shouldShowHighlightsOrientationCard: !Auth.me().isDismissed('homeHighlightsOrientationCard')
                shouldShowFeedbackOrientationCard: false && Auth.me().shouldShowFeedbackCard() # only disable for now, leave for future use
                idOrganization: @currentOrgId(orgname)
                @renderHighlight
                setFixedButton: @setHighlightsFixedButton
              }
